module.exports = __webpack_public_path__ + "static/media/shield-icon.558a00b5.svg";